import { Checkbox, TableCell, TableHead, TableRow } from "@mui/material";
import { memo } from "react";
import { IInforme } from "@/redux/models";

const TableInformeHead = ({ checked, handleSelectAll }: { checked: boolean, handleSelectAll: any }) => {
    return (<TableHead sx={{ bgcolor: 'transparent' }}>
        <TableRow>
            <TableCell>
                <Checkbox
                    color="primary"
                    checked={checked}
                    onChange={handleSelectAll}
                />
            </TableCell>
            <TableCell>Entrada</TableCell>
            <TableCell>Fecha</TableCell>
            <TableCell>Tipo</TableCell>
            <TableCell>Velocidad</TableCell>
            <TableCell>Precio</TableCell>
            <TableCell>Estado</TableCell>
            <TableCell>Acciones</TableCell>
        </TableRow>
    </TableHead>);
}

export default memo(TableInformeHead, (prev, next) => prev.checked === next.checked);